import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_safe_performance_excavation_trenching_work_i_e'

export const dataPointDefinition = {
  retracedId: 'no_safe_performance_excavation_trenching_work_i_e',
  name: 'No safe performance of excavation and/or trenching work (i.e. will damage or disrupt underground utilities, storage tank',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-con-7x',
      number: 'HS-CON-2-5',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-con-2',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-54,Yes',
      machineShowHide: '[2],hs-54,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-con-7x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30560,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
